import { useFeatureFlagEnabled, usePostHog } from "posthog-js/react";

export type FeatureFlag =
  | "agent"
  | "agent-file-upload"
  | "agent-dataset-import"
  | "prediction_profiler"
  | "deep-research"
  | "parameter_importance"
  | "organization-switcher";

export function useFeatureFlag(flag: FeatureFlag): boolean {
  const posthog = usePostHog();
  const isEnabled = useFeatureFlagEnabled(flag);

  // When PostHog is opted out (localdev/test builds), enable all flags so
  // developers can access all features without remote flag config.
  if (posthog.has_opted_out_capturing()) {
    return true;
  }

  return isEnabled ?? false;
}
